import React from "react";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import AddReminderForm from "../../components/forms/reminder/addReminderForm";

const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "Reminder", path: "/reminder" },
    { label: "Add", path: "" },
];

const AddReminder = () => {
    return (
        <div className="flex flex-col gap-2 p-4">
            <PageTableHeader
                breadcrumbs={breadcrumbs}
                isSearch={false}
                isFilter={false}
            />
            <div className="bg-white flex flex-col gap-2 text-theme p-4">
                <AddReminderForm />
            </div>
        </div>
    );
};

export default AddReminder;

